<template>
  <div class="csRelation">
    <div class="select">
      <el-form ref="form" :model="request" label-position="right">
        <el-form-item><el-input v-model="request.csName" placeholder="代理姓名" style="width:200px" clearable></el-input></el-form-item>
        <el-form-item><el-input v-model="request.csPhone" placeholder="代理联系电话" style="width:200px" clearable></el-input></el-form-item>
        <el-form-item>
          <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="getCsList()">搜索</el-button>
          <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="reset()">重置</el-button>
          <el-button style="background-color:#F7FE2E" icon="el-icon-plus" @click="addCs()">添加代理</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableData">
      <el-table :data="response.data" style="margin:auto;width:calc(100% - 30px)" height="681" border  :header-cell-style="{background:'#01DFD7',color:'#fff'}"
                v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading"  element-loading-background="rgba(0.8, 0, 0, 0.3)"
                :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }">
        <el-table-column label="代理编号" align="center" prop="code"></el-table-column>
        <el-table-column label="代理类型" align="center" prop="typeStr"></el-table-column>
        <el-table-column label="代理名称" align="center" width="260" prop="subjectName"></el-table-column>
        <el-table-column label="联系电话" align="center" width="150" prop="phone"></el-table-column>
        <el-table-column label="地区" width="200" align="center" >
           <template slot-scope="scope">{{ scope.row.provinceStr }}{{ scope.row.cityStr}}{{ scope.row.areaStr }}</template>
        </el-table-column>
        <el-table-column label="详细地址" width="420" align="center" prop="address"></el-table-column>
        <el-table-column label="是否开通分润" width="130" align="center">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.rewardFlag === '1'">已开通</el-tag>
            <el-tag type="success" v-else>未开通</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="分润比例" width="100" align="center" prop="rewardPercent"></el-table-column>
        <el-table-column label="详情" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="warning" size="small" plain @click="csDtail(scope.row.code)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
    </div>
    <add-cs v-if="addCsDialog" ref="addCs" @add-succeed="addSucceed"></add-cs>
    <cs-detail v-if="csDtailDialog" ref="csDetail"></cs-detail>
  </div>
</template>

<script>
import { getAllCsList} from "../../api/relation/csrelation";
import { formatDate } from "../../utils/date";
import AddCs from './addCs.vue';
import csDetail from './csDetail.vue'
export default {
  name: "CsRelation",
  data() {
    return {
      request: {
        csName: '',
        phone: '',
        current: '',
        size: ''
      },
      query: {current: 1, size: 15},
      response: {data: [], total: 0},
      loading: false,
      addCsDialog: false,
      csDtailDialog: false,
    };
  },
  components: {
    AddCs,
    csDetail
  },
  methods: {

    /**
     * 查询代理列表
     */
    getCsList() {
      this.request.current = this.query.current;
      this.request.size = this.query.size;
      getAllCsList(this.request).then((result) => {
        this.response.data = result.data.records;
        this.response.total = result.data.total;
      })
    },

    /**
     * 页码改变触发事件
     */
    currenChangeHandle(value) {
      this.query.current = value;
      this.getCsList()
    },

    /**
     * 重置
     */
    reset(){
      this.request.csNmae = "";
      this.request.csPhone = "";
      this.request.current = 1;
      this.request.size = 10;
      this.getCsList();
    },

    /**
     * 添加代理
     */
    addCs(){
      this.addCsDialog = true;
      this.$nextTick(() =>{
        this.$refs.addCs.init();
      })
    },

    /**
     * 监听子组件
     */
    addSucceed(value){
      this.getCsList();
    },

    /**
     * 代理详情
     */
    csDtail(value){
      this.csDtailDialog = true;
      this.$nextTick(() =>{
        this.$refs.csDetail.init(value);
      })
    }
  },
  mounted() {
    this.getCsList();
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  },
};
</script>
<style scoped>
.csRelation {
  width: 100%;
  height: 100%;
}

.el-form {
  float: left;
}

.el-form-item {
    display: inline-block !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/relation/csrelation.vue